// extracted by mini-css-extract-plugin
export default {"bar":"style_bar__vNDZG","company":"style_company__UWN6J","buttons":"style_buttons__7Tdeh","logo":"style_logo__IAsHj"};